import { c as _c } from "react/compiler-runtime";
import Image from "@/components/common/image/image";
import type { ProductFact } from "@/sanity/sanity.types";
import imageUrl from "@/sanity/utilities/imageUrl";
interface ProductFactProps {
  data: ProductFact;
}
const ProductFact = t0 => {
  const $ = _c(18);
  const {
    data
  } = t0;
  let t1;
  if ($[0] !== data.icon) {
    t1 = data.icon?.asset ? imageUrl(data.icon).width(60).url() : "/light-bulb.svg";
    $[0] = data.icon;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = data.heading || "Did you know?";
  let t3;
  if ($[2] !== t1 || $[3] !== t2) {
    t3 = <div className="flex w-[80px] items-center justify-center rounded-l-md bg-[linear-gradient(167deg,_#00698F_-8.61%,_#3BD4AE_104.99%)]"><Image src={t1} alt={t2} width={39} height={66} className="h-[66px] w-[39px]" /></div>;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = data.heading || "Did you know?";
  let t5;
  if ($[5] !== t4) {
    t5 = <span className="font-bold uppercase tracking-[1px] text-[#373A36]">{t4}</span>;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== data.source) {
    t6 = data.source && <span className="italic">- Source: {data.source}</span>;
    $[7] = data.source;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== data.content || $[10] !== t6) {
    t7 = <p className="mt-3 leading-5 text-[#373A36]">{data.content} {t6}</p>;
    $[9] = data.content;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t5 || $[13] !== t7) {
    t8 = <div className="flex-1 rounded-r-md bg-[#F2F2F2] p-4">{t5}{t7}</div>;
    $[12] = t5;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t3 || $[16] !== t8) {
    t9 = <div className="my-8 flex rounded-md bg-[#F2F2F2]">{t3}{t8}</div>;
    $[15] = t3;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  return t9;
};
export default ProductFact;